module.exports = __webpack_public_path__ + "img/diabolical_dr_z_desk.00f0b40e.jpg";